export { default as AvatarShape } from './avatar-shape';

export { default as UploadIllustration } from './upload-illustration';

export { default as ForbiddenIllustration } from './forbidden-illustration';

export { default as MaintenanceIllustration } from './maintenance-illustration';

export { default as ServerErrorIllustration } from './server-error-illustration';

export { default as PageNotFoundIllustration } from './page-not-found-illustration';
